// ============================================================================
// featureFlags — liga/desliga de features SEM apagar código
// ============================================================================
// 07/08/2026 — decisão do dono: o sistema fica focado em PERFORMANCE por
// enquanto; a operação nativa (agenda, atendimento, migração de comandas)
// fica ESCONDIDA, não excluída. Nada foi deletado: rotas continuam vivas
// (acessíveis por URL direta) e os dados continuam no banco — só somem os
// pontos de entrada na UI.
//
// Pra REATIVAR tudo: OCULTAR_NATIVO = false e pronto.
// ============================================================================

export const OCULTAR_NATIVO = true;

// 24/10/2026 — Pacotes Ativos (relatório 904) lê o 0063 do Avec AO VIVO
// (decisão do dono: enquanto a agenda nativa está parada, os créditos vêm do
// Avec). false = volta a ler a foto avec_active_packages (já com o saldo
// certo: total − usadas). O 904 é só do master (soMaster em reports/registry.jsx).
export const PACOTES_ATIVOS_AO_VIVO = true;

// Rotas escondidas do menu lateral (todas as variações de nav/cargo)
export const ROTAS_NATIVAS_OCULTAS = new Set([
  '/gestao/agenda',
  '/gestao/atendimento',
  '/gestao/relatorios/validacao-nativa',
]);

// Filtra itens e filhos de grupos do sidebar
export function filtrarNavNativo(nav) {
  if (!OCULTAR_NATIVO) return nav;
  return nav
    .filter(item => !ROTAS_NATIVAS_OCULTAS.has(item.to))
    .map(item => item.children
      ? { ...item, children: item.children.filter(c => !ROTAS_NATIVAS_OCULTAS.has(c.to)) }
      : item);
}

// 09/10/2026 — Financeiro "Rotina da unidade" (fluxo linear por unidade). false = o
// Financeiro exatamente como depois do SPEC build-ajustes-rotina (HEAD 150c6619).
// Fora da flag (invisíveis na tela): a salvaguarda da competência da comissão
// lançada pelo extrato (api/_lib/fin-extrato-lancar.js), a op GET `vinculos` do
// /api/fin-extrato e os campos origem/origem_key/forma nas sugestões do extrato.
export const FIN_TRILHO_UNIDADE = true;

// 12/10/2026 — "Na Rotina da unidade as ENTRADAS não parecem estar puxando
// corretamente do Avec… entradas × o que caiu na conta × o que tem de caixa".
// true = a etapa ④ da Rotina abre o FECHAMENTO DO DIA ANTERIOR (vendido no Avec
// por forma × depósito da Stone e PIX × gaveta, pistas e "Conferido") em cima da
// agenda de recebíveis; a agenda ganha o aviso do faturamento pelo dia da venda
// e o rótulo "Cartão a cair no período"; Entradas cruza a venda com o depósito.
// false = as telas exatamente como antes (o servidor continua respondendo os
// campos novos, que a tela ignora).
export const FIN_FECHAMENTO_DIA = true;

// 12/10/2026 — "Coloque uma ABA no financeiro com o HISTÓRICO DE SANGRIAS e com
// o VALOR EM DINHEIRO NO CAIXA ATUAL". true = aba "Sangrias e caixa" depois da
// Auditoria (operador; "Fui eu / Não fui eu" só o master). false = sem a aba.
export const FIN_SANGRIAS_CAIXA = true;

// 12/10/2026 — "ela NÃO precisa fechar dia por dia… o sistema precisa entender que foi feito do dia 09
// ao 12" + "avisos apenas na Auditoria". true = Rotina da unidade por PERÍODO, 4 etapas (sem ⑤ Avisos),
// ④ = Fechamento do período (FechamentoPeriodo), régua sem avisos, sem o chip de alertas no cabeçalho.
// false = a Rotina exatamente como no HEAD 18cb5770 (5 etapas, Fechamento do dia).
export const FIN_ROTINA_PERIODO = true;

// 12/10/2026 — "o botão de selecionar a unidade… ruim de enxergar em que unidade você está e para
// trocar". true = faixa "UNIDADE" logo abaixo das abas, com as unidades em botões; false = o <select>.
export const FIN_SELETOR_UNIDADE = true;

// 12/10/2026 — "o fluxo de caixa deixe na barra do lado da DRE". true = aba de topo "Fluxo de Caixa"
// depois de DRE (sai de Entradas e Saídas); false = sub-aba como antes.
export const FIN_FLUXO_TOPO = true;

// 16/10/2026 — "o fluxo de caixa está uma farofa, não consigo entender nada... Quero clareza do fluxo
// de caixa MENSAL". true (junto com FIN_FLUXO_TOPO) = a aba "Fluxo de Caixa" desenha o Fluxo pela conta
// Stone (components/financeiro/FluxoMensalTab, GET /api/fin?op=fluxo): saldo do banco no início e no
// fim, o que entrou e saiu por conta e a Rede, a gaveta e vendido × recebido na Conferência; sem
// FluxoCaixaBancario, sem CashFlowChart e sem a faixa da unidade (como a DRE). false = a aba de antes.
export const FIN_FLUXO_BANCO = true;

// 12/10/2026 — "quero saber quanto tem de dinheiro no momento e o detalhamento das sangrias".
// true = aba Sangrias e caixa simplificada; false = a aba do HEAD 18cb5770.
export const FIN_SANGRIAS_SIMPLES = true;

// 13/10/2026 · IA de atendimento (modo teste). true = item "Atendimento IA" no menu do
// master (Simulador + Pré-agendamentos). Quem pode ver a fila é o SERVIDOR que decide
// (/api/atendimento-fila?op=me); false = nenhum ponto de entrada na UI.
export const IA_ATENDENTE_MENU = true;

// 24/10/2026 · CRM da Sofia (fase 1). true = item "CRM" no grupo "Atendimento IA" do master
// (/gestao/crm-sofia: visão geral, funil, conversas, qualidade da Sofia e configurações). Quem
// vê o quê é o SERVIDOR que decide (/api/crm-sofia?op=me, env CRM_SOFIA); false = nenhum
// ponto de entrada na UI (a rota some junto).
export const CRM_SOFIA_MENU = true;

// 25/10/2026 · CRM da Sofia, a tela nova (Caixa de entrada, ficha do cliente, Clientes) em
// src/components/crm/CrmTrabalho.jsx. Pedido do dono: "o CRM está pouco funcional em relação a
// design... informações do cliente não consigo ver direito" e "tem que parecer um aplicativo
// profissional". true = a tela nova; false = a tela de hoje, exatamente como está (ponto de
// volta). Fica false até o ok do dono no piloto: a prévia local abre a nova com ?demo=1&tela=nova
// (só em DEV). Quem vê o quê continua no servidor.
// 25/10/2026: aprovado pelo dono na tela piloto.
export const CRM_REDESIGN = true;

// 25/10/2026 · CRM da Sofia, a Caixa de entrada ao vivo. Pedido do dono: "normalmente no CRM que
// usamos chega imediatamente; faça de uma forma que não fique tão caro ou pesado, mas que seja
// imediato e funcional". true = a Caixa assina o canal de avisos do Supabase Realtime
// (src/utils/crmTempoReal.js; quem avisa é o banco, migrations/crm-004-tempo-real.sql) e relê na
// hora; a consulta periódica vira reserva de 60 s só com o canal provado (um aviso recebido).
// false = a Caixa exatamente como antes (30 s, 8 s com a conversa sua), sem baixar o Supabase.
export const CRM_TEMPO_REAL = true;

// 27/10/2026 · CRM sem recarga. Queixa do dono: "o CRM a cada minuto apaga tudo e carrega de
// novo". Causa: cada deploy recarregava a página inteira (VersionChecker e service worker) e o
// rascunho vivia só na memória do componente. true =
//   · rascunho por conversa e modo (src/utils/crmRascunhos.js: memória + sessionStorage, 24 h,
//     nunca localStorage), lido ao abrir e limpo ao enviar;
//   · com texto, foco ou envio no campo de resposta, a recarga espera (src/utils/reloadHold.js,
//     trava sem teto só do CRM; o ponto segue 45 s / 60 s) e aparece "Versão nova · Atualizar";
//   · o sync do Avec e o refresh de 60 s do DataContext param na rota do CRM (voltam ao sair);
//   · no iPhone a conversa fica montada (escondida) ao ir para Cliente ou Detalhes;
//   · a conversa só desce sozinha no envio novo ou com quem lê já no fim.
// false = exatamente como antes (recarga a cada deploy, rascunho só na memória).
export const CRM_SEM_RECARGA = true;

// 27/10/2026 · CRM da Sofia, o visual v2 (publicado com o ok do dono em 28/10/2026). Pedido do
// dono: "muito feio, cru, cara de protótipo, cara de IA, MSN; falta profundidade, animação, cor,
// vida; precisa ser profissional". true = superfícies em camadas, balões por autor, chips de estado,
// avatar pela unidade com o ponto do estado, cabeçalho numa faixa só com abas sublinhadas, compositor
// flutuante, ficha em cartões, "Hoje na unidade" e movimento (sempre com motion-safe). Mesma paleta
// azul do DNA, os mesmos dados, os mesmos botões e as mesmas regras. false = o visual de antes,
// exatamente como está (ponto de volta: cada peça escolhe a classe ou o componente antigo).
export const CRM_VISUAL_V2 = true;

// 28/10/2026 · CRM da Sofia, o visual v3 (publicado com o ok do dono em 28/10/2026, junto com o visto
// da equipe da crm-007: negrito e a bolinha com o número, como o WhatsApp). Pedido do
// dono sobre o v2: "melhorou, mas ainda está muito too much; precisa ser mais clean, fácil de enxergar;
// informação repetida nas três telas; falta um barulhinho baixo quando chega mensagem de cliente;
// fontes mais naturais e profissionais; cara de WhatsApp na nossa paleta ou de CRM profissional;
// utilidades; talvez customização". true (e CRM_VISUAL_V2 true) = cada dado num lugar só, lista plana
// de 2 linhas, balões com rabinho, fonte do sistema (SF no iPhone e no Mac), não lidas, respostas
// rápidas e a ficha que abre no botão abaixo de 1600 px. Só vale com o v2 ligado.
// false = o v2 exatamente como está (cada peça escolhe a classe ou o componente do v2).
export const CRM_VISUAL_V3 = true;

// 28/10/2026 · o som baixo de mensagem nova de cliente no CRM (só com o v3). Dois toques curtos e
// suaves (WebAudio, nada baixado), no máximo um a cada 3 s, só depois do primeiro tick, só fala de
// cliente (nunca a Sofia, a recepção ou o próprio envio), só a última aba do CRM em foco toca. Cada
// pessoa liga, desliga e ajusta o volume em Aparência. false = silêncio, nada muda na tela.
export const CRM_SOM = true;

// 28/10/2026 · Aparência do CRM (só com o v3): cor de destaque, densidade, tamanho do texto, fundo da
// conversa, som e aviso do navegador, por pessoa e só neste navegador. O azul do DNA é o padrão e a
// única cor que alguém vê sem escolher outra. As outras cores dependem do ok do dono ("paleta nunca
// muda sem ele"). false = sem a engrenagem, tudo no padrão.
export const CRM_APARENCIA = true;

// 30/10/2026 · o vigia de mensagem nova do CRM em todas as telas do DNA. Pedido do dono: "notificação de
// mensagem para quando a recepcionista estiver no computador e estiver fora do DNA, por exemplo no Avec,
// ou em outra aba do DNA e não tiver no CRM ... elas estão se perdendo. O som também não está
// funcionando." true = para quem tem o CRM no menu, uma aba por navegador lê só as conversas com fala
// nova (GET ?op=avisos, inclusive com a aba escondida) e avisa: com o DNA em foco, o som; fora dele, o
// push do computador ou o aviso do navegador; o "(N)" no título de todas as telas; o som destrava em
// qualquer clique do DNA, com um aviso no canto quando ficou travado depois de recarregar, e fica mais
// alto (o padrão sai de -29 para -14 dBFS); a Caixa nunca toca duas vezes a mesma fala.
// false = exatamente como antes (som e aviso só dentro da Caixa, o volume de antes).
export const CRM_VIGIA = true;

// 16/10/2026 · Feel King Private: "esconda o Feel King Private de todos os usuários, que
// desisti de vender" (dono). true = some o item do menu para TODOS os cargos (inclusive o
// master), o relatório 013 sai da lista, o Radar volta ao selo "novo" e às mensagens normais
// e a rota /gestao/privates manda para a tela inicial, exceto o master (abre pelo link).
// Nada é apagado: tabelas, contratos, telas e o cron continuam. O servidor tem o espelho
// PRIVATES_ATIVO em api/_lib/privates-flag.js (um teste garante PRIVATES_ATIVO === !OCULTAR_PRIVATES).
// false (e PRIVATES_ATIVO = true no servidor) = exatamente como antes.
export const OCULTAR_PRIVATES = true;

// A rota é do módulo Private? (o item do menu e as sub-rotas /gestao/privates/…)
export function ehRotaPrivates(to) {
  return typeof to === 'string' && (to === '/gestao/privates' || to.startsWith('/gestao/privates/'));
}

// 17/10/2026 — "o sistema deve reconhecer as contas já categorizadas para não precisar ficar lançando o
// que foi toda vez" (New Concept = Produtos Feel King). true = no débito pendente do Extrato Stone (Rotina ② e
// Auditoria), a linha "Como da última vez" (mesma marcação da sugestão de conta, 1 ou 2 botões) abre o
// formulário de sempre já preenchido como a última conta (categoria, descrição, fornecedor, unidade do
// custo, rateio) e só o Salvar grava; "Lançar os N iguais" (Muito provável, sem rateio, desde 08/10) com o
// painel do lote de Comissões; o "Lançar em Contas a Pagar" comum deixa de marcar a categoria escondida; a
// Nova Conta a Pagar ganha "Da última vez … [Usar]" (GET /api/fin-extrato?op=ultima-vez). false = as telas
// exatamente como antes (o servidor continua mandando ultima_vez, que a tela ignora).
export const FIN_ULTIMA_VEZ = true;

// 20/10/2026 — VALES (financeiro-013): "quando um vale sai por PIX da Stone e é lançado no extrato
// como vale, escolhe-se o profissional daquela unidade e ele é descontado no PRÓXIMO pagamento (só quem
// está na folha; comissionados o Avec desconta)" (dono). true = no débito pendente do Extrato Stone
// (Rotina ② e Auditoria) a pergunta "PIX para {nome} ({unidade}): é vale?" com o botão "Vale"; no
// formulário de sempre, com a categoria do vale, o campo "Profissional *" (Na folha / Comissionados), o
// mês do desconto e as parcelas (ou a competência do comissionado); o lote "Lançar como Comissões" recusa
// quem está na folha; Contas a Pagar ganha o vale na Nova Conta (a pagar até o "Vincular e dar baixa"),
// "É vale" numa conta que já existe (com confirmação e motivo) e o vale na edição (só leitura, cancelar
// antes do desconto); a Folha ganha a seção "Vales" (por pessoa: dia, valor, conta, mês do desconto,
// descontado, saldo, situação, ajustes). false = as telas exatamente como antes (a categoria nova "Vale
// de comissionado" fica fora da escolha). Quem decide é o SERVIDOR (chave vales_folha, financeiro-013):
// a linha do vale na folha e o Marcar paga seguem a chave, não esta flag (sem isso a pessoa com vale
// levaria 409 ao marcar paga).
// 22/10/2026: LIGADA (decisão do dono: "OK para publicar com os vales LIGADOS"). Ordem: o push com esta
// flag em true, a 910 com falhas = [] e a financeiro-013 logo em seguida (antes da 013 o servidor responde
// "rode a financeiro-013" e nada é gravado). Voltar: false aqui e um novo deploy (com a 013 aplicada, ver o
// cabeçalho dela: a guarda do Adiantamento a funcionário pede o campo do profissional).
export const FIN_VALES = true;

// 22/10/2026: EDIÇÃO SEGURA DE CONTA (lapidação do financeiro, etapa E; diagnóstico 1.6). Pedido do dono:
// "garantir que nada se perde". true = editar uma conta em Contas a Pagar ou no Calendário relê a conta do
// banco ao abrir e manda SÓ os campos que mudaram (status, data e forma do pagamento só quando o "Pagar"
// mudou; o comprovante só quando mudou), com a condição "a versão é a que abri": se outra pessoa (ou o
// sistema) mexeu na conta depois, nada é gravado e a tela diz "Esta conta mudou desde que você abriu;
// recarreguei."; desfazer o pagamento e tirar o comprovante pedem o motivo (painel de motivo de sempre; o
// motivo vai para a trilha). Cancelar e reabrir também levam a versão. false = as telas e os pedidos
// exatamente como antes. O banco tem os interruptores dele (financeiro-018: versao_titulo e
// motivo_desfazer_titulo); com a 018 aplicada, voltar esta chave para false pede também
// motivo_desfazer_titulo = 0 (a tela antiga não manda motivo e o banco recusaria desfazer o pagamento).
export const FIN_EDICAO_SEGURA = true;

// 22/10/2026: EXTRATO SEM DUPLICIDADE. Pedido do dono, depois de subir o extrato do mês inteiro: "ficou
// pedindo para categorizar todas as saídas novamente. Quando já categorizamos uma saída o sistema deve
// entender e bloquear essa duplicidade de categorização. Também deve bloquear extratos que não são das
// respectivas contas" e "o sistema não pode ficar pedindo para categorizar nas rotinas do financeiro e
// extrato o que já foi categorizado". O servidor tem os espelhos em api/_lib/fin-extrato-flags.js.
// Cada flag false = a tela como antes do hotfix 5aa8d2f3 (o resto da integração continua: vales, proteção dos dados
// e alertas sem ruído; o servidor pode mandar campos novos, que ela ignora). 22/10/2026 (integração, revisão 1): antes
// dizia "exatamente como no HEAD e0fbb503", o que já não vale depois da junção.
// REVERSÃO SEMPRE EM PAR com o servidor (revisão 1, 22/10/2026): FIN_JA_LANCADA com jaLancada, FIN_TRAVA_DUPLICIDADE
// com travaDuplicidade, FIN_ANTES_DA_ROTINA com antesDaRotina, FIN_EXTRATO_CONTA_CERTA com contaCerta (FLAGS_EXTRATO em
// api/_lib/fin-extrato-flags.js). Só a tela desligada não volta ao de antes: o servidor ligado tira o "Como da última vez"
// da saída com conta igual, recusa o Lançar com 409 conta_igual (que a tela antiga mostra como erro solto) e recusa o
// arquivo sem número (que a tela antiga tenta confirmar de novo). travaDuplicidade desligada tira também a trava da conta
// igual no vale lançado pelo extrato (lancarDoExtrato, caminho do vale, acrescentada na junção dos vales).
// (1) a saída que já tem conta igual em Contas a Pagar aparece "Já lançada em Contas a Pagar: …" com o
//     Vincular (todas as iguais, nada escolhido sozinho) e "Vincular todas as que só têm uma conta igual";
//     a régua conta essas saídas como "vincular" e a seleção de Comissões e o lote não as pegam.
export const FIN_JA_LANCADA = true;
// (2) o "Lançar em Contas a Pagar" do extrato recusado por conta igual mostra as contas com o Vincular (quem faz a
//     rotina lança mesmo assim, com o motivo); a Nova Conta a Pagar avisa (não trava) conta parecida.
export const FIN_TRAVA_DUPLICIDADE = true;
// (3) "Só pendentes" começa em 08/10: a saída de antes não aparece como pendente; uma linha discreta diz
//     quantas do período estão fora da rotina, com o "Ver" (filtro próprio). Nada é apagado nem decidido sozinho.
export const FIN_ANTES_DA_ROTINA = true;
// (4) o envio do extrato: arquivo sem número de conta é recusado (com o porquê) e "confirmar a conta" só
//     aparece para o dono, com o motivo.
export const FIN_EXTRATO_CONTA_CERTA = true;

// ============================================================================
// 23/10/2026: DASHBOARD SEM ZERO SILENCIOSO (investigação ws920ub8r, prints de 22/10 21:14).
// Regras do dono: "sem dado = vazio + aviso, nunca 0" e "dado real do Avec, nunca estimar".
// Cada chave false = exatamente como antes desta rodada. PUBLICAÇÃO POR PARTES (o teste
// tests/dash-flags-reversao.test.mjs confere o valor de cada fase):
//   P1 servidor (api/_lib/avec-flags.js) e P2 coleta e carga: nascem LIGADAS, telas iguais;
//   P3 telas e P4 Mac: nascem DESLIGADAS; ligar só depois de medir a P2 (log do proxy e
//   _coleta.falhou) e avisar o dono. Voltar atrás = false aqui + deploy; os ~50 iPhones só
//   recebem depois que o service worker atualiza (vigia inline), de minutos a horas.
// ============================================================================
// ── P2: coleta e carga ──
// A1 estado por relatório na coleta ao vivo (_coleta/_falhas/_visitasFonte): relatório que
// falhou vira null (nunca 0) e o cache mensal herda o valor anterior do mesmo mês. Telas
// antigas continuam iguais (null cai no `|| 0` delas); unidade com falha não vira snapshot.
export const AVEC_COLETA_ESTADO = true;
// A2a nova tentativa em falha passageira (403 do Avec, 429, 5xx, rede, timeout, corpo não
// JSON) SÓ para o que a pessoa está vendo (prioridade 0 e 1) e para o "Tentar de novo";
// fundo (sync de 60 s, grade diária, 12 meses) tenta 1 vez. Disjuntor por aparelho.
export const AVEC_RETENTATIVA = true;
// A2b pedido idêntico em voo vira UMA chamada (ex.: 0031 página 1 pedido 2 vezes por unidade).
export const AVEC_DEDUPE_EM_VOO = true;
// A2b fila global com prioridade e teto adaptativo para os relatórios sem CDN. DESLIGADA:
// a simulação (tests/avec-retentativa-limitador.test.mjs) mostra a rodada do sync mensal
// passando de 60 s com o Dashboard aberto; com a fila o tick seguinte seria pulado, e isso
// é reduzir a frequência do sync (precisa do ok do dono antes de ligar). Só vale com
// AVEC_RETENTATIVA ligada.
export const AVEC_LIMITADOR = false;
// A2b constante de ajuste (não é interruptor): teto inicial de chamadas sem CDN ao mesmo
// tempo por aparelho. O Avec recusa com 5 simultâneas (api/_lib/atendimento-avec.js).
export const AVEC_LIMITE_PESSOAIS = 3;
// A2b constante de ajuste (revisão 23/10/2026, achado 18): piso do teto adaptativo (cada
// 403/429 baixa 1 até aqui). Simulação para levar ao dono antes de ligar a fila
// (tests/avec-retentativa-limitador.test.mjs, "simulação revisão"), rodada do sync mensal:
// teto 5 e piso 4 sem 403 = 35 s (46 s com o Dashboard aberto); 1 em 40 com 403 = 58 s
// com o Dashboard; 1 em 8 = 105 s com o Dashboard (as pausas de cada 403 dominam); piso 1
// com 1 em 8: 197 s. Fica 1 (o de hoje) até a decisão, que depende da taxa real de 403.
export const AVEC_PISO_PESSOAIS = 1;
// A2c Dashboards não pedem o que não usam: sem o leque do 0065 e sem o 0225; o Meu
// Desempenho pede só a unidade da pessoa (e só depois de saber qual é). A chave do cache
// do período passa a ter a variante (unidades, 0031 paginado, 0065) e um teto de 8 chaves.
export const DASH_PEDIDO_ENXUTO = true;
// A2c (revisão 23/10/2026) sem a fila (AVEC_LIMITADOR desligada), os Dashboards pedem o
// período anterior DEPOIS do atual (antes: os dois juntos, somando os picos na abertura).
// Os números são os mesmos; o % aparece alguns segundos depois. false = os dois juntos.
export const DASH_ANTERIOR_DEPOIS_DO_ATUAL = true;
// A8a aparelho sem sessão válida (tela de login, sessão legada) não roda o sync mensal, a
// grade diária, o self-heal nem os 12 meses; ao logar começam, ao sair param.
export const AVEC_SYNC_SO_COM_SESSAO = true;
// A8b último sync do APARELHO em chave própria, lida sem NaN; nada sobe para a nuvem; o
// self-heal deixa de forçar (o force pulava a proteção do cache mensal).
export const AVEC_ULTIMO_SYNC_JSON = true;
// A9 grade diária fk_avec_daily_cache: falha sem valor anterior fica AUSENTE (não 0) e um
// 200 vazio não apaga valor bom (src/utils/gradeDiaria.js).
export const AVEC_GRADE_DIARIA_GUARDA = true;
// A2a 2xx JSON sem data.report = falha. DESLIGADA até conferirem, com leitura única e
// espaçada, o envelope que o Avec devolve para período vazio legítimo em 0002, 0012, 0031,
// 0062, 0064, 0089, 0123, 0007, 0229, 0065 e 0024 (o log [avec] upstream do proxy mostra
// corpo 'sem_report' quando acontece). Corpo não JSON (HTML do nginx, vazio) já é falha.
export const AVEC_EXIGE_REPORT = false;
// ── P3: telas (nascem desligadas) ──
// A4b período passado completo reaproveitado da memória por 2 h (até com force); resultado
// com falha nunca é servido de cache; refazer o MESMO período passado herda o que faltou.
// Só dentro da sessão: no iPhone cada reabertura do PWA busca o anterior de novo (rangeStore.js).
export const RANGE_CACHE_PROTEGIDO = false;
// A4a período anterior com o dia limitado ao último dia do mês anterior (31/10 → 30/09;
// 29-31/03 → 28/02) e mês fechado inteiro contra o mês anterior inteiro (fechamento oficial).
export const PERIODO_ANTERIOR_TRUNCADO = false;
// A5 comissão da unidade montada do cache = soma real do 0123 (a pagar + adiantamentos);
// sem o 0123: o fechamento local; sem nada: sem dado. Nunca 40% do faturamento.
// DEPENDE de DASH_SEM_DADO (revisão 23/10/2026): sem a tela nova, o null da comissão
// viraria R$ 0,00 silencioso no sum() do Dashboard e no gráfico de 12 meses; a chave
// efetiva é COMISSAO_UNIDADE_REAL && DASH_SEM_DADO (avecPerformanceMerger.js).
export const COMISSAO_UNIDADE_REAL = false;
// A5b no mês corrente, campo do cache cujo relatório falhou cai no fechamento local
// (fk_unit_performance) em vez de entrar como 0; só vale junto de AVEC_COLETA_ESTADO
// E de DASH_SEM_DADO (mesmo motivo da A5).
export const MES_CORRENTE_FALHA_USA_FECHAMENTO = false;
// A3 gestão (Dashboard admin/gerente, Taxa de Retorno, Rankings semanais): relatório que não
// veio = "Sem dado" + aviso de quais unidades faltaram + "Tentar de novo" (refaz só o que
// faltou); a rede só soma o que veio de TODAS; razões e % só com os dois lados completos.
// 24/10/2026: ligada (passo 1 da P3, só a gestão), a pedido do dono.
export const DASH_SEM_DADO = true;
// A3 app da equipe (Meu Desempenho): o mesmo "Sem dado", sem estimativa nem pró-rata.
export const PRO_SEM_DADO = false;
// A3 Duelos: par com relatório faltando mostra "Sem dado" e não grava vencedor.
export const DUELOS_SEM_DADO = false;
// ── P4: sync do Mac (nasce desligada; só vale depois do pull no ~/fk-cloud do Mac) ──
// A7 guarda anti-zero ampliada no scripts/avec-daily-sync.mjs: comissão (0123), produtos
// (0041) e pacotes (0062) que falharam não gravam 0 no fechamento oficial (mantém o anterior;
// sem anterior grava vazio). Antes da 1ª rodada ligada: backup do fk_unit_performance.
// Env FK_GUARDA_ANTIZERO_AMPLIADA=0 desliga sem editar o código.
export const SYNC_GUARDA_ANTIZERO_AMPLIADA = false;

// ============================================================================
// 23/10/2026: RODADA 2 (trilha r2). Cada chave false = exatamente como antes.
// ============================================================================
// ITEM 1, TRAVA CONTRA O SEED (o dono aprovou). Em 05/09 um aparelho com o
// armazenamento vazio semeou 310 dias de faturamento falsos (fk_daily_revenue),
// 15 metas (fk_unit_metas) e 4 configurações (fk_unit_config) e subiu tudo para o
// cofre. true = o aparelho não semeia mais fk_daily_revenue nem fk_unit_metas
// (src/data/seedData.js e src/utils/storage.js initStorage); fk_daily_revenue sai da
// trava de encolhimento (que empurrava a cópia local inteira) e do backfill; item local
// com o carimbo do seed que o cofre não tem é tirado da cópia local antes do merge
// (fk_daily_revenue e fk_unit_metas: assim a remoção das metas falsas não volta nem
// congela o aparelho da equipe); o boot não chama mais o pushToCloud quando a
// migração rodou e o cofre não respondeu; "Resetar Dados" (Configurações) só troca a
// cópia local pela do cofre, sem semear e sem enviar nada; a edição do Meta x
// Realizado grava origem 'manual'. O servidor tem a trava dele (SEED_TRAVADO_SERVIDOR
// em api/_lib/data-merge.js), independente desta.
export const SEED_TRAVADO = true;

// ITEM 2, FOLHA DE QUEM TRABALHA EM DUAS UNIDADES (o dono decidiu: somar). Caso do Kayk
// em out/2026: Moema R$ 3.152,30 + Oscar R$ 581,70 = R$ 3.734,00 (a folha pagava só a maior).
// true = a folha automática (src/utils/payrollAuto.js) soma a comissão do mês entre as
// unidades; dentro da MESMA unidade continua valendo a maior (duplicata de nome no Avec).
// É a régua do comissaoPorProf do financeiro (api/_lib/fin-regras.js). false = a maior.
export const FOLHA_SOMA_UNIDADES = true;
// fk_performance: o merge do APARELHO (src/utils/storage.js) identifica o registro por id +
// unidade. O script do Mac é quem decide quais unidades a pessoa tem no mês: registro local
// de (profissional, ano, mês) que o cofre já tem, com id + unidade que o cofre não tem, sai
// da cópia local antes do merge (id antigo × id novo, unidade tirada pelo script, registro
// que o dedupe do script tirou). Mesma regra do servidor, então o aparelho não devolve ao
// cofre nem guarda o que o servidor recusaria (sem disputa com o script, sem congelar a
// equipe na trava de encolhimento). Leitores (ranking, desafios, folha, Dashboard do
// profissional) procuram por profissional, ano e mês, nunca pelo id, então os dois formatos
// valem. Nasce LIGADA porque precisa estar no ar ANTES do script gravar o id novo. O servidor
// tem o espelho PERF_CHAVE_COM_UNIDADE_SERVIDOR em api/_lib/data-merge.js.
// false = o merge por id de antes.
export const PERF_MERGE_POR_UNIDADE = true;
// Script do Mac (scripts/avec-daily-sync.mjs, revisão da rodada 2): a limpeza de duplicata do
// fk_performance baixado e a guarda anti-zero por (profissional, unidade, ano, mês), com o id
// ainda no formato antigo. Sem isso o dedupe por id descarta a Oscar do Kayk (mesmo id da
// Moema) em todo passe que não reprocessa outubro. Nasce LIGADA: não depende do app novo nos
// aparelhos (o cofre já tem hoje os dois registros com o mesmo id). A duplicata exata (Filipi
// jun/2026) continua saindo. Vale só depois do pull no ~/fk-cloud do Mac.
// Env FK_SYNC_DEDUPE_COM_UNIDADE=0 desliga sem editar o código. false = o dedupe por id de sempre.
export const SYNC_DEDUPE_COM_UNIDADE = true;
// Script do Mac (scripts/avec-daily-sync.mjs, lê esta chave como a SYNC_GUARDA_ANTIZERO_AMPLIADA):
// só o FORMATO do id do registro novo de fk_performance, com a unidade
// (`${profId}-${unitId}-${ano}-${mês}`). Ligada, também força o dedupe e a guarda por
// (profissional, unidade, ano, mês), porque os dois formatos convivem no arquivo. O dedupe e a
// guarda em si são a SYNC_DEDUPE_COM_UNIDADE (acima), que não espera esta. Nasce DESLIGADA:
// ligar só depois que o app com PERF_MERGE_POR_UNIDADE estiver nos aparelhos (1 dia); vale só
// depois do pull no ~/fk-cloud do Mac. Env FK_SYNC_ID_COM_UNIDADE=0 desliga sem editar o código.
// false = o id de sempre.
export const SYNC_ID_COM_UNIDADE = false;

// ITEM 3, RÉGUA DE ATENDIDOS (o dono decidiu: "comanda com serviço", 0089 no mês aberto e as
// comandas do 0031 no fechamento, que dão o mesmo número). O 0002 deixa de entrar escondido
// no lugar do 0089: ele deixa de fora clientes antigos inteiros (5% a 26% a menos; Moema
// mostrou 357 em vez de 473 no comparativo de 01 a 22/09). true = na coleta ao vivo
// (src/services/avecSync.js, só junto de AVEC_COLETA_ESTADO) atendidos = 0089; 0089 que
// falhou, ou zerado sem o 0031 confirmar que não houve serviço, vira as comandas únicas
// (data + número) do 0031 paginado quando ele veio inteiro, senão sem dado (null); a herança
// do cache mensal não reaproveita valor do 0002; o scripts/rebuild-avec-snapshots.mjs não
// grava a unidade sem o 0089 (mantém o snapshot que já existe). O 0002 continua só para
// clientesUnicos. Nenhum mês fechado muda. Com DASH_SEM_DADO DESLIGADA (revisão da rodada 2):
// os cartões antigos leem `visitas || 0`, então quando a régua nova não tem número (0089
// falhou e não há 0031 paginado, caso do sync mensal de 60 s) a coleta fica com a régua de
// hoje (0002 se respondeu) e a herança do cache volta a aceitar o valor do 0002; nunca vira
// null nem zera ticket e produtividade sem aviso. O "sem dado" de verdade só junto da tela
// nova (DASH_SEM_DADO). false = exatamente como antes (0089 > 0, senão 0002).
export const ATENDIDOS_SO_COMANDA_SERVICO = true;

// 28/10/2026, pedido do dono: "esse sync automático do Avec não faz muito sentido; quando a gente
// quiser ver uma atualização, a gente mesmo recarrega a página". false: o Avec só sincroniza ao
// abrir a página, ao trocar o mês e no botão de atualizar (sem o polling de 60 s nem o da volta à
// aba). true volta ao de antes.
export const AVEC_SYNC_PERIODICO = false;

// 28/10/2026, CADASTRO SEM SEED (caso Renato; o dono: "Eu não aguento mais toda hora a gente
// resolver o mesmo erro"). Em 28/10 14:46 um iPhone de gestão com o armazenamento apagado
// ressemeou os 46 cadastros do seed (src/data/seedData.js, sem updatedAt), o ETag guardado fez a
// leitura do cofre voltar "não mudou" e a descoberta de CPF subiu a lista inteira (já tinha
// acontecido em 19/05 e 19/10). true = (1) o initStorage (src/utils/storage.js) nunca mais semeia
// profissionais, unidades, usuários nem feriados (fk_initialized, merge de novos, v9 e a v32 dos
// aliases); sem cópia, a lista fica vazia até o cofre responder, com o aviso do Layout; (2) quando
// o initStorage acha o aparelho apagado (sem fk_initialized) ou muda alguma chave do cofre, esquece
// o ETag dela e a primeira leitura vem cheia; (3) a descoberta de CPF (PerformanceContext) só roda
// depois que fk_professionals foi APLICADO do cofre nesta sessão e manda só o cpf
// ({ silent, campos: ['cpf'] }); (4) updateProfessional, addProfessional e deleteProfessional
// leem a cópia crua (sem os aliases do seed); (5) "Bloquear/Desbloquear dia" (Metas) só grava
// depois que os dias fechados foram conferidos com o cofre nesta sessão (lista vazia + cofre fora
// apagaria todos os dias guardados). O servidor tem a trava dele, independente desta
// (CADASTRO_TRAVA_COPIA_SERVIDOR em api/_lib/data-merge.js). false = exatamente como antes.
export const CADASTRO_SEED_TRAVADO = true;

// 29/10/2026, META QUE NÃO VOLTA (Meta de Moema: o dono trocou 400 → 340 mil em menos de 5 min e
// as recepcionistas ficaram presas no 400). O merge por updatedAt (src/utils/storage.js) deixava
// QUALQUER item local com carimbo de menos de 5 min vencer o cofre, inclusive o que acabou de vir
// do próprio cofre; o empurrão da equipe volta 403, o aparelho confirmava o ETag e dali em diante
// o cofre respondia "não mudou" para sempre. true = (1) a janela de 5 min só protege o item
// gravado NESTE aparelho nesta sessão; (2) se o merge manteve um item local mais velho que o do
// cofre, o ETag não é confirmado (a próxima leitura vem cheia e confere de novo); (3) uma vez por
// aparelho, as chaves que passam pelo merge relêem inteiras (sara quem já ficou preso). false =
// exatamente como antes.
export const MERGE_JANELA_SO_LOCAL = true;
